export const environment = {
  name: 'production',
};
